export const buildAdTargeting = ({ isAdFreeUser, isSensitive, edition, section, sharedAdTargeting, adUnit, videoDuration, }) => {
    if (isAdFreeUser) {
        return {
            disableAds: true,
        };
    }
    const customParams = {
        sens: isSensitive ? 't' : 'f',
        si: 'f',
        vl: videoDuration || 0,
        cc: edition,
        s: section,
        inskin: 'f',
        ...sharedAdTargeting,
        pa: 'f',
    };
    return {
        customParams,
        adUnit,
    };
};
